export function buildAddProductFormData(data) {
  const formData = new FormData();

  // חובה
  formData.append('business_id', data.business_id);
  formData.append('product_id', data.product_id);

  // מחירים (לא שולחים אם ריק)
  if (data.price !== '' && data.price !== null && data.price !== undefined) {
    formData.append('price', data.price);
  }

  if (data.original_price !== '' && data.original_price !== null && data.original_price !== undefined) {
    formData.append('original_price', data.original_price);
  }

  if (data.sale_price !== '' && data.sale_price !== null && data.sale_price !== undefined) {
    formData.append('sale_price', data.sale_price);
  }

  // מלאי
  if (data.stock_quantity !== '' && data.stock_quantity !== null && data.stock_quantity !== undefined) {
    formData.append('stock_quantity', data.stock_quantity);
  } else {
    formData.append('stock_quantity', 99);
  }

  // מצב מלאי
  formData.append('stock_status', data.stock_status || 'in_stock');

  // switches (boolean -> string)
  formData.append('is_visible', data.is_visible ? 'true' : 'false');
  formData.append('is_displayed', data.is_displayed ? 'true' : 'false');

  // כותרת מותאמת
  if (data.custom_title && data.custom_title.trim() !== '') {
    formData.append('custom_title', data.custom_title);
  }

  // תמונה
  if (data.custom_image instanceof File) {
    formData.append('custom_image', data.custom_image);
  }

  return formData;
}